export default {
  page: {
    url: '/fbaReimbursements/page',
    method: 'post',
    desc: '赔偿报告-分页'
  },
  comments: {
    url: '/fbaReimbursements/comments',
    method: 'post',
    desc: '赔偿报告-备注'
  },
}
